import {ActionType} from "typesafe-actions";
import * as actions from "./actions";
import {BonusType} from "../player/types";

export interface IHintsState {
    readonly appliedHints: Record<string, BonusType[]>;
    readonly activeHints: Record<string, BonusType[]>;
}

export type HintsActions = ActionType<typeof actions>;

export function getLevelMapHintsId(levelId: number) {
    return 'l_' + levelId;
}

export function getQuestionHintsId(questionId: number) {
    return 'q_' + questionId;
}

export function getLevelMapHints(hints: Record<string, BonusType[]>, levelId: number) {
    return hints[getLevelMapHintsId(levelId)] || [];
}

const emptyBonusArray: BonusType[] = [];
export function getQuestionHints(hints: Record<string, BonusType[]>, questionId: number) {
    return hints[getQuestionHintsId(questionId)] || emptyBonusArray;
}